import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  borderColors,
  ColorsConstants,
  inputColor,
} from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const AppDatePicker = ({
  value,
  onChange,
  minDate,
  disableFuture = false,
  error = false,
  helperText = "",
  placeholder = "DD/MM/YYYY",
  fullWidth = true,
  format = "DD/MM/YYYY", // dayjs-style tokens; pass format="dd/MM/yyyy" when using AdapterDateFns
  slotProps: externalSlotProps = {}, // ← extract slotProps separately
  ...props
}) => {
  return (
    <DatePicker
      value={value}
      onChange={onChange}
      minDate={minDate}
      disableFuture={disableFuture}
      format={format}
      openTo={props.openTo ?? (props.views?.includes("day") ? "day" : "month")}
      slotProps={{
        ...externalSlotProps, // ← spread external ones first
        textField: {
          ...externalSlotProps.textField, // ← merge textField overrides
          size: "small",
          error,
          helperText,
          placeholder,
          sx: {
            ...typography.bodyLarge,
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              height: 40,
              color: inputColor,
              ...typography.bodyLarge,
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "8px",
                borderColor: borderColors.inputFieldGrey,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: ColorsConstants.primaryGray50,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: ColorsConstants.primaryGray100,
              },
            },

            width: fullWidth ? "100%" : "fit-content",
          },
          InputProps: {
            sx: {
              height: 40,
              "& input": {
                padding: "8px 14px !important",
                boxSizing: "border-box",
                color: inputColor,
                ...typography.bodyLarge,
              },
              "& input::placeholder": {
                color: inputColor,
                opacity: 1,
              },
              "& .MuiInputAdornment-root": {
                height: "100%",
              },
              "& .MuiIconButton-root": {
                padding: "6px",
              },
            },
          },
        },
      }}
      {...props}
    />
  );
};

export default AppDatePicker;
